import React, { useEffect, useState } from "react";
import Sidebar from "./sidebar";
import { connect } from "react-redux";
import { withSocket } from "../../../../socket/context";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

const Wrapper = (props) => {
  const { children } = props;
  const [color, setColor] = useState('')
  let parameter = props.paramsReducer.gameObj;

  useEffect(() => {
    if (Object.keys(parameter).length > 0 ) {
      hexToRGB(parameter?.tabletop_placemat_rgb, parameter?.tabletop_placemat_transparency)
    }
  }, [])

  const hexToRGB = (hex, alpha) => {
    var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      setColor("rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")")
    } else {
      setColor("rgb(" + r + ", " + g + ", " + b + ")")
    }
  }
  return (
    <div className="dw20-game">
      <div className="wrapper">
        <Sidebar />
        <div className="dw20-content-wrapper">
          <div className="dw20-content" style={{ backgroundColor: color }}>{children}</div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  withRouter,
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(Wrapper);
